import React, { useContext, useMemo } from 'react';
import operEsrrService from '../../../../services/operEsrrService';
import useService from '../../../../shared/hooks/useService';
import Context from '../Esrr/EsrrContext';
import MainContext from '../../../App/MainProvider/context';

const IndicatorProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { inSuperUserMode, inGuidanceServiceMode } = useContext(MainContext);
  const [esrrQuestions, loadingEsrrQuestions] = useService(operEsrrService.getEsrrQuestions, [
    inSuperUserMode(),
    inGuidanceServiceMode(),
  ]);

  const value = useMemo(
    () =>
      esrrQuestions &&
      !loadingEsrrQuestions && { questions: esrrQuestions, loadingQuestions: loadingEsrrQuestions },
    [esrrQuestions, loadingEsrrQuestions]
  );

  return value && <Context.Provider value={value}>{children}</Context.Provider>;
};

export default IndicatorProvider;
